import React from 'react';
export default function AudioView(props) {
  return (
    <audio controls>
      <source src={props.media.url} type="audio/mpeg" />
    </audio>
  );
}
